import { Link, useNavigate } from "react-router-dom";
import SidBarClient from "./SideBarClient";
import "./homeclient.css";
import "../visiteur/Homevisiteur.css"; // Import the exact visitor page styles for uc2 cards
import { useContext, useEffect, useState } from "react";
import { MagasinContext } from "../../../Context/MagasinContext";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import DefaulteImage from "../../Admin/IMG/DefaulteImage.jpeg";
import axios from "axios";
import EmptyCartPopup from "../../../components/EmptyCartPopup";
import BugReportButton from "../../../components/BugReportButton";
import Timer from "../../../components/Timer";
import './PremiumButton.css';

interface Product {
  id: string;
  name: string;
  imageUrl: string;
  price: string;
  ref: any;
  vendeur?: string;
  PrixNetHT?: string;
  quantity: number;
}

export default function HomeClient() {
  const [products, setProducts] = useState<Product[]>([]);
  const [Totale, setTotale] = useState<number>(0);
  const magasinContext = useContext(MagasinContext);

  const ClientId = localStorage.getItem('ClientId');
  const ClientName = localStorage.getItem('ClientName');
  const idClient = ClientId || magasinContext.id?.id;
  const NameClient = ClientName || magasinContext.id?.NomMagasin;

  const [clientRemise, setClientRemise] = useState<number>(0);
  const [commissionRules, setCommissionRules] = useState<any[]>([]);

  const [soldeValue, setSoldeValue] = useState<number>(0);
  const [soldeLoading, setSoldeLoading] = useState(true);
  const maxSolde = 10000;
  const soldePercent = Math.min((soldeValue / maxSolde) * 100, 100);

  const fetchSolde = () => {
    if (!idClient) return;
    setSoldeLoading(true);
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/profile`)
      .then(res => {
        const c = res.data?.client;
        if (c) {
          const s = parseFloat(c.credit ?? c.Credit ?? c.Solde ?? c.Compte ?? "0");
          setSoldeValue(isNaN(s) ? 0 : s);
          localStorage.setItem("SoldeClient", isNaN(s) ? "0" : s.toString());
          const r = parseFloat(c.RemiseGlobal ?? c.RemiseGlobale ?? "0");
          setClientRemise(isNaN(r) ? 0 : r);
        } else {
          setSoldeValue(0);
        }
      })
      .catch(() => {
        setSoldeValue(0);
      })
      .finally(() => setSoldeLoading(false));
  };

  useEffect(() => {
    fetchSolde();
    // Listen for solde updates dispatched after checkout
    window.addEventListener("solde-updated", fetchSolde);
    return () => window.removeEventListener("solde-updated", fetchSolde);
  }, [idClient]);

  const [searchInput, setSearchInput] = useState(""); // controlled input value
  const [search, setSearch] = useState("");           // actual query sent to API
  const [gridProducts, setGridProducts] = useState<ArticleInfo[]>([]);
  const [magasinProducts, setMagasinProducts] = useState<any[]>([]);

  useEffect(() => {
    const fetchCommission = async () => {
      try {
        const r = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`);
        setCommissionRules(r.data || []);
      } catch {
        setCommissionRules([]);
      }
    };
    fetchCommission();
  }, []);

  useEffect(() => {
    if (!idClient) return;
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/client/${idClient}/magasin`)
      .then(res => {
        if (res.data?.NomMagasin) {
          setAssignedMagName(res.data.NomMagasin);
          localStorage.setItem('MagasinLieeName', res.data.NomMagasin);
        }
      })
      .catch(() => {});
  }, [idClient]);

  const getGlobalCommission = (): number => {
    const globalRule = commissionRules.find((r: any) => r.commission_type === "global");
    if (globalRule) return parseFloat(globalRule.commission_value) || 0;
    return 0;
  };

  const getMagasinCommission = (nomMagasin?: string): number => {
    if (!nomMagasin) return 0;
    const magasinRule = commissionRules.find(
      (r: any) =>
        r.commission_type === "magasin_all" &&
        r.source_magasin_name?.toLowerCase() === nomMagasin?.toLowerCase()
    );
    if (magasinRule) return parseFloat(magasinRule.commission_value) || 0;
    return 0;
  };
  
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const navigate = useNavigate();

  // ── Filters (client-side) ──
  const [filterMoinsCher, setFilterMoinsCher] = useState(false);
  const [filterDisponible, setFilterDisponible] = useState(false);
  const [shopFilter, setShopFilter] = useState<string>("tout les produits");
  const [assignedMagName, setAssignedMagName] = useState<string>(localStorage.getItem('MagasinLieeName') || '');

  // Quantity Management for each card
  const [cardQuantities, setCardQuantities] = useState<{ [id: string]: number }>({});
  const [addedToCart, setAddedToCart] = useState<{ [id: string]: boolean }>({});
  const [addingToCartId, setAddingToCartId] = useState<string | null>(null);

  const getQuantity = (id: string) => cardQuantities[id] ?? 1;
  
  const changeQuantity = (id: string, delta: number) => {
    setCardQuantities(prev => {
      const next = Math.max(1, (prev[id] ?? 1) + delta);
      return { ...prev, [id]: next };
    });
  };

  const handleAddToCart = async (pro: any) => {
    const baseId = pro.IdArticle ?? pro.id ?? pro.idArticle ?? '';
    const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
    if (!id || id === '_global') return;
    
    const qty = getQuantity(id);
    setAddingToCartId(id);

    try {
      const pHT = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteTTC ?? pro.PrixTTC ?? pro.PrixVente ?? "0").replace(",", "."));
      const commissionWyn = getGlobalCommission();
      const oldPrice = clientRemise > 0
        ? pHT * (1 + commissionWyn / 100) * (1 + clientRemise / 100)
        : pHT * (1 + commissionWyn / 100);
      const calcFinal = clientRemise > 0
        ? oldPrice * (1 - clientRemise / 100)
        : oldPrice;
      const finalPrice = isNaN(calcFinal) ? 0 : calcFinal;

      const finalRef = pro.RefArticle || pro.ref || pro.Ref || id;
      const finalName = pro.Designation || pro.name || pro.NomArticle || "Article";
      const finalImg = pro.urlImage || pro.image || pro.Image || DefaulteImage;
      const finalNomMag = pro.NomMagasin || "Magasin";
      // 1. Post to backend /panier
      const formData = new FormData();
      formData.append("IdUtilisateur", idClient || '');
      formData.append("IdClient", idClient || '');
      formData.append("TypeUtilisiteur", "clients");
      formData.append("IdArticle", String(pro.IdArticle || pro.id || baseId));  // real article ID
      formData.append("RefArticle", finalRef);
      formData.append("Designation", finalName);
      formData.append("Image", finalImg);
      formData.append("price", finalPrice.toString());
      formData.append("quantity", qty.toString());
      formData.append("NomMagasin", finalNomMag);
      formData.append("seller", finalNomMag);

      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, formData);
      localStorage.setItem('cartExpiration', String(Date.now() + 50 * 60 * 1000)); // 50 minutes

      // 2. Save/Update in frontend local storage
      let localCart: Product[] = [];
      const stored = localStorage.getItem('productsClient');
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          localCart = Array.isArray(parsed) ? parsed : [];
        } catch {
          localCart = [];
        }
      }

      const existingIndex = localCart.findIndex(item => item.id === id);
      if (existingIndex !== -1) {
        localCart[existingIndex].quantity += qty;
      } else {
        localCart.push({
          id: id,
          name: finalName,
          imageUrl: finalImg,
          price: finalPrice.toString(),
          PrixNetHT: finalPrice.toString(),
          quantity: qty,
          ref: finalRef,
          vendeur: finalNomMag,
        });
      }

      localStorage.setItem('productsClient', JSON.stringify(localCart));
      setProducts(localCart); // update right sidebar cart instantly!

      // Start counter timer if empty before
      if (!localStorage.getItem("StartDate")) {
        localStorage.setItem("StartDate", new Date().toISOString());
      }

      setAddedToCart(prev => ({ ...prev, [id]: true }));
      setTimeout(() => {
        setAddedToCart(prev => ({ ...prev, [id]: false }));
      }, 2500);

    } catch (err) {
      console.error("Error adding to cart", err);
    } finally {
      setAddingToCartId(null);
    }
  };

  // Unified CartTimer handles the expiration via localStorage

  // Load products — passes active filters to the server so ALL articles are filtered/sorted
  const fetchArticles = async (page = 1, query = "", sortParam = '', disponibleParam = false, filterMag = shopFilter) => {
    setLoading(true);
    try {
      const magParam = filterMag === "Mes Produits" ? (assignedMagName || localStorage.getItem('MagasinLieeName') || '') : '';
      if (query.trim() !== "") {
        const params: Record<string, string> = { q: query, page: String(page), perPage: '12' };
        if (sortParam) params['sort'] = sortParam;
        if (disponibleParam) params['disponible'] = '1';
        if (magParam) params['magasinName'] = magParam;
        const res = await axios.get(
          `${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
          { params }
        );
        setGridProducts(res.data.data || []);
        setCurrentPage(res.data.current_page || 1);
        setTotalPages(res.data.total_pages || 1);
      } else {
        const params: Record<string, string> = { page: String(page), perPage: '20' };
        if (sortParam) params['sort'] = sortParam;
        if (disponibleParam) params['disponible'] = '1';
        if (magParam) params['magasinName'] = magParam;
        const res = await axios.get(
          `${process.env.REACT_APP_PHP_APP_URL}/topArticles`,
          { params }
        );
        setGridProducts(res.data.data || []);
        setCurrentPage(res.data.current_page || 1);
        setTotalPages(res.data.total_pages || 1);
      }
    } catch (err) {
      console.error("Error loading articles", err);
      setGridProducts([]);
    } finally {
      setLoading(false);
    }
  };

  // Fetch on mount & whenever filter buttons change (server-side filtering)
  useEffect(() => {
    const sortParam = filterMoinsCher ? 'price_asc' : '';
    setCurrentPage(1);
    fetchArticles(1, search, sortParam, filterDisponible, shopFilter);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterMoinsCher, filterDisponible, shopFilter, assignedMagName]);

  // Trigger search on Enter key
  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const val = searchInput.trim();
      setSearch(val);
      setCurrentPage(1);
      const sortParam = filterMoinsCher ? 'price_asc' : '';
      fetchArticles(1, val, sortParam, filterDisponible);
    }
  };

  // Clear search when input is emptied
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchInput(val);
    if (val.trim() === '') {
      setSearch('');
      setCurrentPage(1);
      const sortParam = filterMoinsCher ? 'price_asc' : '';
      fetchArticles(1, '', sortParam, filterDisponible);
    }
  };

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    const sortParam = filterMoinsCher ? 'price_asc' : '';
    fetchArticles(page, search, sortParam, filterDisponible);
  };

  const deleteProduct = (id: string, updateProducts: (products: Product[]) => void) => {
    let arr: Product[] = [];
    const localStorageData = localStorage.getItem('productsClient');
    if (localStorageData) {
      arr = JSON.parse(localStorageData);
    }
    const updatedProducts = arr.filter(product => product.id !== id);
    localStorage.setItem('productsClient', JSON.stringify(updatedProducts));
    updateProducts(updatedProducts);

    if (updatedProducts.length === 0) {
      localStorage.removeItem("StartDate");
      localStorage.removeItem("cartExpiration");
      window.dispatchEvent(new Event("panier-updated"));
    }
  };

  const sumQty = () => {
    let total = 0;
    for (let i = 0; i < products.length; i++) {
      const priceVal = parseFloat(String(products[i].price).replace(",", "."));
      const QtyXprice = (isNaN(priceVal) ? 0 : priceVal) * Number(products[i].quantity);
      total += QtyXprice;
    }
    setTotale(total);
  };

  useEffect(() => {
    sumQty();
  }, [products]);

  useEffect(() => {
    const storedProducts = localStorage.getItem('productsClient');
    if (storedProducts) {
      try {
        setProducts(JSON.parse(storedProducts));
      } catch (error) {
        console.error('Error parsing products from local storage', error);
      }
    }
  }, []);

  const handleDeleteProduct = (id: string) => {
    deleteProduct(id, setProducts);
  };





  // Filtering/sorting is now handled server-side — display all returned articles as-is
  const displayList = gridProducts;

  return (
    <div className="client-dashboard-wrapper">
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      <SidBarClient />

      <main className="client-main-content">
        {/* Header */}
        <div className="client-header">
          <div>
            <h1 className="client-header-title">
              Tableau de bord, <span>{NameClient}</span>
            </h1>
            <p className="client-header-subtitle">
              Bienvenue sur votre espace client. Recherchez par référence et passez vos commandes.
            </p>
          </div>
        </div>

        {/* Layout Grid */}
        <div className="client-grid-layout">
          {/* Left Column: Segmented Filters + Search + Products grid */}
          <div className="client-left-col">


            {/* Search Box + Filters */}
            <div className="client-search-box mb-3">
              <i className="bi bi-search client-search-icon"></i>
              <input
                type="text"
                value={searchInput}
                onChange={handleSearchInput}
                onKeyDown={handleSearchKeyDown}
                className="client-search-input"
                placeholder="Rechercher... (appuyez Entrée)"
              />
            </div>

            {/* Store Filter Buttons */}
            <div className="d-flex gap-2 mb-3 flex-wrap">
              {[
                { v: "tout les produits", l: "Tous les produits" },
                { v: "Mes Produits", l: "Mes Produits" },
              ].map(({ v, l }) => (
                <button
                  key={v}
                  onClick={() => setShopFilter(v)}
                  className="px-3 py-2 rounded-3 border fw-semibold"
                  style={{
                    fontSize: '0.85rem', cursor: 'pointer', transition: 'all .15s',
                    background: shopFilter === v ? '#F5A623' : '#fff',
                    color: shopFilter === v ? '#fff' : '#334155',
                    borderColor: shopFilter === v ? '#F5A623' : '#CBD5E1',
                    boxShadow: shopFilter === v ? '0 2px 6px rgba(245, 166, 35, 0.3)' : 'none'
                  }}
                >
                  {l}
                </button>
              ))}
            </div>

            {/* Filter Buttons */}
            <div className="d-flex gap-2 mb-4 flex-wrap">
              <button
                onClick={() => setFilterMoinsCher(v => !v)}
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3 border fw-semibold"
                style={{
                  fontSize: '0.82rem', cursor: 'pointer', transition: 'all .15s',
                  background: filterMoinsCher ? '#0B1220' : '#fff',
                  color: filterMoinsCher ? '#fff' : '#334155',
                  borderColor: filterMoinsCher ? '#0B1220' : '#CBD5E1',
                }}
              >
                <i className="bi bi-graph-down-arrow" />
                Moins chers
                {filterMoinsCher && <i className="bi bi-check-lg" />}
              </button>

              <button
                onClick={() => setFilterDisponible(v => !v)}
                className="d-flex align-items-center gap-2 px-3 py-2 rounded-3 border fw-semibold"
                style={{
                  fontSize: '0.82rem', cursor: 'pointer', transition: 'all .15s',
                  background: filterDisponible ? '#0B1220' : '#fff',
                  color: filterDisponible ? '#fff' : '#334155',
                  borderColor: filterDisponible ? '#0B1220' : '#CBD5E1',
                }}
              >
                <i className="bi bi-box-seam" />
                En stock
                {filterDisponible && <i className="bi bi-check-lg" />}
              </button>
            </div>

            {/* Bottom Products List Grid */}
            <div>
              <div className="client-section-header">
                <h2 className="client-section-title">
                  Notre Collection Globale
                </h2>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2 text-muted">Mise à jour des produits...</p>
                </div>
              ) : (
                <>
                  {displayList.length > 0 ? (
                    <>
                      <div className="product-grid-row-hvu">
                        {displayList.map((pro) => {
                          const pHT = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteArticleTTC ?? pro.PrixVente ?? pro.Prix ?? "0").replace(",", ".").trim()) || 0;
                          const commissionWyn = getGlobalCommission();
                          const oldPrice = clientRemise > 0
                            ? pHT * (1 + commissionWyn / 100) * (1 + clientRemise / 100)
                            : pHT * (1 + commissionWyn / 100);
                          const calcFinal = clientRemise > 0
                            ? oldPrice * (1 - clientRemise / 100)
                            : oldPrice;

                          const cleanPrice = calcFinal.toFixed(2);
                          const baseId = pro.IdArticle ?? pro.id ?? '';
                          const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
                          
                          // Robust quantity extraction to handle encoding issues like "Quantit"
                          const qtyKey = Object.keys(pro).find(k => k.toLowerCase().startsWith('quantit') || k.toLowerCase() === 'qte' || k.toLowerCase() === 'stock');
                          const availableQty = qtyKey ? Number(pro[qtyKey]) : 0;
                          const outOfStock = isNaN(availableQty) ? true : availableQty <= 0;

                          const finalImg = pro.urlImage || pro.image || pro.Image || DefaulteImage;
                          const isAdded = addedToCart[id] ?? false;
                          const isAdding = addingToCartId === id;
                          const qty = getQuantity(id);

                          return (
                            <div className={`uc2-card-hvu ${outOfStock ? "uc2-card-nostock-hvu" : ""}`} key={id}>
                              <div className="uc2-img-zone-hvu">
                                <img
                                  src={finalImg}
                                  alt={pro.Designation}
                                  className={`uc2-img-hvu ${outOfStock ? "uc2-img-grey-hvu" : ""}`}
                                />
                                <span className="uc2-brand-chip-hvu">{pro.NomMarque ? pro.NomMarque : "Pièce"}</span>
                                {outOfStock ? (
                                  <div className="uc2-stock-badge-hvu uc2-stock-out-hvu">
                                    <i className="bi bi-x-circle-fill" /> Stock épuisé
                                  </div>
                                ) : (
                                  <div className="uc2-stock-badge-hvu uc2-stock-in-hvu">
                                    <i className="bi bi-check-circle-fill" /> En stock
                                  </div>
                                )}
                              </div>

                              <div className="uc2-body-hvu">
                                <div className="uc2-stars-hvu">
                                  {[...Array(5)].map((_, i) => (
                                    <i key={i} className="bi bi-star-fill uc2-star-i-hvu" />
                                  ))}
                                </div>

                                <Link className="uc2-title-link-hvu" to={`/clients/${idClient}/articles/${pro.IdArticle}`} state={{ article: pro }}>
                                  <div className="uc2-title-hvu">
                                    {pro.Designation}
                                  </div>
                                </Link>

                                <div className="uc2-ref-badge-wrap">
                                  <span className="uc2-ref-badge" title={`Réf: ${pro.RefArticle || pro.reference || pro.Reference || pro.ref || ''}`}>
                                    <i className="bi bi-hash" /> Réf : {pro.RefArticle || pro.reference || pro.Reference || pro.ref || "N/A"}
                                  </span>
                                </div>

                                <div className="uc2-price-hvu">
                                  {clientRemise > 0 && pHT > 0 && (
                                    <span style={{ textDecoration: 'line-through', color: '#9CA3AF', fontSize: '0.85rem', marginRight: '8px', fontWeight: 600 }}>
                                      {oldPrice.toFixed(2)} MAD
                                    </span>
                                  )}
                                  {cleanPrice}
                                  <span className="uc2-currency-hvu"> MAD</span>
                                </div>

                                {!outOfStock && (
                                  <div className="uc2-cart-row-hvu mt-3">
                                    <div className="uc2-qty-hvu">
                                      <button
                                        className="uc2-qty-btn-hvu"
                                        onClick={e => { e.preventDefault(); changeQuantity(id, -1); }}
                                        aria-label="Moins"
                                      >−</button>
                                      <input
                                        className="uc2-qty-input-hvu"
                                        type="number"
                                        min={1}
                                        value={qty}
                                        onClick={e => e.preventDefault()}
                                        readOnly
                                      />
                                      <button
                                        className="uc2-qty-btn-hvu"
                                        onClick={e => { e.preventDefault(); changeQuantity(id, +1); }}
                                        aria-label="Plus"
                                      >+</button>
                                    </div>
                                    <button
                                      className={`uc2-add-btn-hvu ${isAdded ? "uc2-add-btn-done-hvu" : ""}`}
                                      onClick={e => { e.preventDefault(); handleAddToCart(pro); }}
                                      disabled={isAdding}
                                      style={{ height: '36px', fontSize: '0.78rem' }}
                                    >
                                      {isAdding
                                        ? <><span className="btn-spinner-hvu" /> ...</>
                                        : isAdded
                                        ? <><i className="bi bi-check-lg" /> Ajouté</>
                                        : <><i className="bi bi-cart-plus" /> Ajouter</>}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      {/* Grid Pagination */}
                      {totalPages > 1 && (
                        <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                          <button
                            className="btn btn-sm btn-outline-warning px-3"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{ borderRadius: '8px' }}
                          >
                            Précédent
                          </button>
                          <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                            Page <strong>{currentPage}</strong> sur {totalPages}
                          </span>
                          <button
                            className="btn btn-sm btn-outline-warning px-3"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={{ borderRadius: '8px' }}
                          >
                            Suivant
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center py-5 border rounded bg-white" style={{ boxShadow: 'var(--c-shadow-xs)' }}>
                      <i className="bi bi-emoji-neutral text-muted" style={{ fontSize: '2.5rem' }}></i>
                      <h5 className="mt-3 text-dark">Aucun produit trouvé</h5>
                      <p className="text-muted">Essayez avec une autre référence ou contactez notre équipe commerciale.</p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Right Column: LoyaltyCard + Premium Adapted Solde & Panier */}
          <div className="client-right-sidebar">

            {/* Premium Adapted Metallic Solde Wallet Card */}
            <div className="client-solde-premium-wallet">
              <div className="wallet-glow"></div>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="wallet-title">
                  <i className="bi bi-wallet2" /> PORTFEUILLE SOLDE
                </span>
                <span className="wallet-logo-glow">WYN</span>
              </div>
              <div className="wallet-balance-zone">
                <span className="wallet-balance-amount">
                  {soldeLoading
                    ? <span className="spinner-border spinner-border-sm text-light" role="status" />
                    : soldeValue.toLocaleString("fr-FR", { minimumFractionDigits: 2 })}
                </span>
                <span className="wallet-currency">MAD</span>
              </div>
              <div className="wallet-limit-text">
                Limite Autorisée: {maxSolde.toLocaleString("fr-FR")} MAD
              </div>
              <div className="wallet-progress-track">
                <div className="wallet-progress-fill" style={{ width: `${soldePercent}%` }}></div>
              </div>
            </div>

            {/* Premium Adapted Shopping Cart Section */}
            <div className="client-cart-premium-box">
              <div className="client-cart-header">
                <span className="d-flex align-items-center gap-2">
                  <i className="bi bi-basket3 text-warning" /> Panier d'achat
                </span>
                <span className="badge bg-warning text-dark rounded-pill px-2.5 py-1">{products.length}</span>
              </div>

              {products.length > 0 ? (
                <>
                  <div className="client-cart-items-list">
                    {products.map((item) => {
                      const cleanItemPrice = parseFloat(String(item.price ?? "0").replace(",", ".")).toFixed(2);
                      return (
                        <div key={item.id} className="client-cart-item">
                          <img src={item.imageUrl ? item.imageUrl : DefaulteImage} alt={item.name} className="client-cart-item-img" />
                          <div className="client-cart-item-info">
                            <div className="client-cart-item-name">{item.name}</div>
                            <div className="client-cart-item-qtyprice">
                              Qté: {item.quantity} &bull; <span className="text-dark font-weight-bold">{cleanItemPrice} MAD</span>
                            </div>
                          </div>
                          <button
                            onClick={() => handleDeleteProduct(item.id)}
                            className="client-cart-item-delete"
                            title="Supprimer ce produit"
                          >
                            <i className="bi bi-x-circle-fill"></i>
                          </button>
                        </div>
                      );
                    })}
                  </div>

                  <div className="client-cart-footer">
                    <div className="client-cart-total d-flex justify-content-between align-items-center mb-3">
                      <span>Total HT/TTC :</span>
                      <span className="text-primary font-weight-bold h5 mb-0">{Totale.toFixed(2)} MAD</span>
                    </div>
                    <button className="client-checkout-btn text-center" onClick={() => products.length === 0 ? setShowEmptyCartPopup(true) : navigate(`/client/${ClientId}/panier`)} style={{ border: 'none', cursor: 'pointer', width: '100%' }}>
                      <i className="bi bi-cart-check-fill me-1"></i> Consulter le panier
                    </button>
                  </div>
                </>
              ) : (
                <div className="text-center py-4 text-muted">
                  <i className="bi bi-cart-x text-muted" style={{ fontSize: '2rem' }}></i>
                  <p className="mt-2" style={{ fontSize: '0.82rem' }}>Votre panier est vide</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      {/* ===== FLOATING ACTION BUTTONS ===== */}
      <div className="client-floating-actions">
        {products.length > 0 && (
          <div className="client-floating-timer">
            <Timer userId={ClientId || ""} userType="client" asFloating={false} />
          </div>
        )}
        <Link to={`/clients/${ClientId}/assistance`} className="client-floating-btn support-btn">
          <i className="bi bi-headset"></i>
        </Link>
      </div>

      {/* Floating Bug Report Button (Left Side) */}
      <BugReportButton />
    </div>
  );
}
